import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const dashboardOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.DASHBOARD,
    steps: [
        {
            id: "dash-welcome",
            title: "Bem-vindo ao Dashboard!",
            description:
                "Aqui você tem uma visão geral de toda a sua operação em tempo real. Vamos conhecer os principais recursos.",
            position: "center",
            icon: "MdHome",
        },
        {
            id: "dash-kpi",
            title: "Indicadores em tempo real",
            description:
                "Estes cards mostram os KPIs da sua operação: corridas ativas, motoristas online, passageiros em viagem e faturamento do dia.",
            targetId: "dashboard-kpi-cards",
            position: "bottom",
        },
        {
            id: "dash-charts",
            title: "Gráficos e Estatísticas",
            description:
                "Acompanhe a evolução das corridas, receita e tendências. Use os filtros para ajustar o período de análise.",
            targetId: "dashboard-charts",
            position: "top",
        },
        {
            id: "dash-map",
            title: "Mapa de Calor",
            description:
                "Visualize a concentração da demanda e a posição dos motoristas online em tempo real no mapa.",
            targetId: "dashboard-map",
            position: "top",
        },
        {
            id: "dash-done",
            title: "Tudo pronto!",
            description:
                "Você pode repetir este tour a qualquer momento clicando no ícone de ajuda (?) no topo da página.",
            position: "center",
        },
    ],
};
